module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "11",
      "epub:type": "pagebreak",
      "id": "page11",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("The sharp metal shard sliced into her thigh. The passenger side airbag exploded against her body, the steel and aluminum shell of the Mercedes caving in around her. Glass shattered into hundreds of tiny flying projectiles.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy Robbins grabbed for something—anything—as the sedan skidded along the wet pavement and then careened to a stop.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Everything went ear-numbingly quiet. She swatted away the deflated airbag but did not spot the truck that had struck their vehicle. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Gone. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Fled the scene.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Pain shot into her left shoulder as she turned her head to check on Dan. He was not moving, his bloody face having left a ghoulish imprint on the crumpled surface of the airbag.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dan—"), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("wake up")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy forced her head around toward the rear seat. “Lindy. Open your eyes!” The little girl’s mouth hung open, her jaw slack. “Lindy, look at mommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Smoke curled through the interior, the acrid fumes burning Amy’s nose. She tried to reach into the back, but the shoulder "), _c('span', {
    attrs: {
      "aria-label": "12",
      "epub:type": "pagebreak",
      "id": "page12",
      "role": "doc-pagebreak"
    }
  }), _vm._v("harness had an iron grip on her torso. She could not unlock the mechanism.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Dan kept some kind of device in the car that had a razor on one end for slicing seat belts and a small hammer on the other for breaking glass. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dan, "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("wake up")]), _vm._v(",” she said as her fingers fumbled for the glovebox. She spread her legs as far as she could, released the latch, and pulled the lid open. Forcing her right hand into the opening, she scraped the skin off her knuckles and drew blood.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Lindy, can you hear me?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("No reply. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy’s fingers found the hard plastic of the emergency device’s handle. After extracting it—her lubricated, bloody skin sliding out easier than it had gone in—she maneuvered the sharp razor against the edge of the seat belt material and drew its blade firmly across the dense polyester weave. It parted with clean edges.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thank God,” she whispered into the smoky interior. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As she slammed the compartment shut, bright red blood bubbled from the wound on her thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With a grunt and a yank, she removed Dan’s canvas belt, pulled it tightly around her leg, and did her best to knot it. The makeshift tourniquet in place, she set about getting the passenger door open. She repeatedly bashed her right shoulder against it, creating just enough space to push her torso through.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy used her arms to leverage the rest of her body out of the vehicle and sprawled face up onto the wet pavement. Rain continued to fall, steadily but modestly.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She struggled to her feet and tried the rear door. It popped open. The odor of gasoline flared her nostrils. Off to her right the orange flicker of a flame danced from beneath the crumpled hood.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "page13",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A cry emerged from deep in her throat as she cut through the seat belt holding Lindy in place. She pulled the girl’s body against hers and shimmied out of the backseat. As she limped away from the Mercedes, she glanced over her shoulder and saw flames slithering from the front of the sedan. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The smoke was getting thicker.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy set Lindy’s body down thirty feet away, then stumbled back toward the car. She pulled the front passenger door open a few more inches and climbed inside, checked Dan’s pulse, and felt a faint throbbing beneath her finger.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Danny, wake up! Please, honey …” The words choked in her throat and she coughed hard.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy moved the seat as far back as it would go, then sliced through the polyester belt. The interior was getting hotter and the flames were crawling across the windshield. A voice inside her head was screaming at her:"), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v(" Get out now.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Amy …” Dan’s eyes fluttered open. “… Lindy.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Got her out. Help me get "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("you")]), _vm._v(" out.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Fire.” He coughed. “Hot …” His head fell back against the seat.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Dammit.” She shook his shoulders. “Honey, stay with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy struggled in the close quarters to face away from him, then grabbed his arms and drew them around her neck. His dead weight draped across her back. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A sharp pain dug into her thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She pivoted forward and half fell out of the Mercedes with Dan dragging behind, his hulk clunking and banging into the door jamb and then his shoes scraping over the wet pavement as she struggled to handle his mass.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy pushed herself a foot at a time, exhausted as the rain pelted her face and head. She reached Lindy, fell to her knees—and Dan’s body collapsed atop her.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "page14",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("A loud blast muffled her hearing as objects flew in her direction.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Seconds later, billowing smoke enveloped them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left"
  }, [_vm._v("AMY BOLTED UPRIGHT IN BED, her body dripping with perspiration, her breathing rapid and her mouth cotton dry. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She slapped at her clock and silenced the braying alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy sat there trying to calm her nerves. She had been through this nightmare many times during the past seven years and had resigned herself to spending the rest of her life—however long that would be—with the memories haunting her sleep as they haunted her waking moments. No matter what therapy she tried, the pain persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She summoned the strength to get out of bed. She had showered … well, she wasn’t sure when she last showered. Had to be a couple of days ago.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("With stringy hair covering half her face, she padded across the studio apartment into the bathroom. She fell onto the toilet and peed, then washed and towel dried her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her previously luscious, impeccably styled blonde mane was now brushed back and pulled into a bun. Easy, no work required. No expensive hours-long salon visits. That was in her past. These days, fifteen minutes at Great Clips and she was good to go. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("When she looked in the mirror she did not recognize the woman who stared back at her. She still had the youthful skin, but she was getting stress lines. Her smile was no longer radiant. Her sunny disposition had vanished the moment that truck slammed into her car.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She pushed the bottle of Lexapro aside and glanced at the clock. No makeup necessary for this job, so she grabbed her purse and headed out the door.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "page15",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("All told, she rolled into Grand Lake Bakery at 11:05.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’re late, Amy. Again.” Ellen Macafree shook her head. “What am I gonna do with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sorry. It’s only five minutes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not the point,” Ellen said. “You’re late every day and every day we have the same discussion about being professional, showing up on time for appointments, and acting like you care.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I know. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sorry doesn’t cut it.” Ellen studied her face. “Do you want this job?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Do I want this job?” Amy’s gaze found the industrial-chic ceiling, black painted ductwork, and low hanging LED lights. “I "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("need")]), _vm._v(" this job.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen frowned, then turned and walked to her desk a dozen feet away. “Then act like it. We "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("need")]), _vm._v(" five dozen baguettes in the oven in the next ninety minutes. And then start on the banana muffins.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yes ma’am.” Amy pulled the netting over her head and slipped on a white apron.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The position had come open six months ago. Amy’s brother was a regular customer of Grand Lake Bakery and saw the help wanted sign. His sister needed a job and he escorted her into the shop that afternoon to fill out an application.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("All Amy had to do was follow the recipes and operate the machinery. It was rote work. Perfect for her.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy turned to see Bobby, a baker who had worked there for twenty-three years, returning from the restroom. He was tying his apron behind him as he walked up to the oven and checked inside.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You on till closing?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy grumbled. “If I don’t get fired before then.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "page16",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What now?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby laughed. “Lemme guess. Late again?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy busied herself with the dough and did not reply. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby went about his work, using a flat, long-handled wooden spatula to push a tray of sourdough bread deep into the clutches of the oven. A moment later, he glanced in Amy’s direction. “How about we catch a movie at the Grand Friday night?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy’s hands froze, embedded in thick dough. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A film,” Bobby said, pulling over a tray. “Friday night, the Grand.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah, I heard you.” Amy resumed her kneading. “This a date?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Whatever you wanna call it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby was a stoner, but at least with marijuana now kinda sorta legal—the wisdom of California voters notwithstanding—he wasn’t doing anything wrong. But Amy could not stand the sickly-sweet aroma of pot—found it nauseating—and could always smell it on Bobby’s clothes when she went into the break room.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thanks,” Amy said. “But you’re like a gazillion years older than me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So what?” Bobby put down the wooden tool and looked at her. “Is that an issue?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not like you’ve got better offers.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy froze. “And how would you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I can tell.” He waited a beat, then said, “Am I wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“None of your business. And no … not interested in the movie.” A minute passed. “But thanks for asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah. Whatever.” Bobby slammed the oven door shut.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("The phone rang and Ellen walked into her adjacent office and picked it up.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "page17",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Bobby came up alongside Amy. “I didn’t mean anything by it. Sorry if I upset you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy nodded—and inched to her right.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I just … it doesn’t take a genius to see you’re … I dunno. Lonely, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy stepped another foot farther away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” Ellen said into the phone. “You told me you’d be done with the job a month ago. It’s now a month past "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("that")]), _vm._v(". I want your men onsite tomorrow at eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen’s office was about ten feet away and the door was open. Amy glanced over, not intending to eavesdrop yet having no choice but to hear the argument.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No,” Ellen said again, louder. “I want the whole project finished by the end of this month. I’ve got a wedding in my backyard in five weeks. I can’t have any construction going on and I need that deck and arbor finished.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy again looked at Ellen. The owner’s shoulders were hunched and her left hand was balled in a fist.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No. No. That’s not acceptable, Arturo. You promised me a completion date—that you’ve extended four times. And you’re not any closer to finishing than you were a couple weeks ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen listened another moment, then leaned back hard in her seat. “I don’t care if you’ve got other jobs. That’s not my fault and it’s not my problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She dropped the handset away from her mouth. “And what should I tell my daughter?” Ellen disconnected the call and let her head fall backward, her eyes studying the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy walked over, her gloved hands covered in flour. “So your contractor promised a completion date. Is that written in your contract?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen chuckled. “Yes. A lot of good that’s done.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you have a payback clause?”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "page18",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She looked up at Amy. “A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“If contractors exceed their estimated time of completion, they have to pay you a set amount per day until they finish. It prevents them from jerking you around. Encourages good behavior on their part, prioritizes your job. It incentivizes them to finish on time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen swiveled her chair to face Amy. “My minimum wage employee who kneads dough all day is giving me legal advice?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy moved back to her work surface, shrugged, and pounded a fist into the dough. “I … it’s just something I happen to know, is all.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen came over and studied her face. “You’re serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She glanced at her watch. “Get that last batch in the oven, then clean up. We’re gonna grab a late lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy felt a sense of dread descend on her. She should not have intervened like that—now Ellen was going to want to know who she really was. Her right eyelid began twitching, an effect of the accident, or more accurately the stress and emotional trauma it caused.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They walked into Lakeside Grill and a middle-aged woman near the front recognized Ellen. “I’ve got a table by the window, the one you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Thanks so much, Joan.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("They slid into their seats and Joan handed them menus.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy looked it over quickly and set it down.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That was fast. You eat here a lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“First time.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You hardly looked at the menu.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy shrugged. “Burger. Fries. Not too hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And not too healthy. How’d you manage to pick the only junk food they serve?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("She bobbed her head disinterestedly. “It’s salty.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "page19",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen scrunched her brow. “Whatever. I’m not your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan returned and took their orders. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You have any beer?” Amy asked.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Beer?” Joan’s eyes drifted over to Ellen. “Yeah, we’ve got lots. What kind do you—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Porter. Anything dark and bitter.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Sure. How about Old Rasputin Russian Imperial Stout? Made in Fort Bragg and I—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan did not bother writing it down. “Do you want that with your burger?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Now. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As Joan backed away, she threw another look at Ellen—which was not lost on Amy.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You obviously come here a lot,” Amy said, rolling her paper napkin between her left thumb and index fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’ve known Joan since I opened the bakery.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Twenty-three years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy nodded. “Hmm. So Bobby’s been with you since the beginning.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah,” Ellen said with a chuckle. “You could say that. He’s my ex-husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“He’s what?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen frowned and nodded. “Hard to believe. But true.” She waved a hand. “Only lasted a couple of years. I still care about him. But I realized he wasn’t gonna amount to anything and I cut my losses. I bought him out of his half of the bakery—which wasn’t worth much at the time because it was a new business—and I let him stay on. He got into drugs and, well, he needed this. I couldn’t stand to see him out on the street. Because that’s where he’d have ended up.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "page20",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan set the pint of beer in front of Amy along with a glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy reached out and took the bottle and looked it over.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So where’d you learn about contractors and contracts?” Ellen asked. She leaned forward across the table. “I’m not buying the ‘just something I happen to know’ explanation.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy stared at the beer. She abruptly lifted it and drank for a few seconds, draining half of it. She set it back on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Your employment application doesn’t mention anything about being a legal secretary.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I wasn’t.” She stole a glance at Ellen, who was looking at her with narrow eyes. Amy gathered up the beer and finished it. She set the bottle down firmly. “I was an attorney. "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("Am ")]), _vm._v("an attorney. I—uh, whatever.” She grabbed Joan’s arm as she passed and held up the empty Old Rasputin with her other hand. “Another, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan glanced at Ellen, whose brow was knitted, her top teeth biting her lower lip. “You sure, miss? I mean, it’s only one o’clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Yeah,” Amy said. “I’m sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("As Joan moved off, Ellen touched Amy’s wrist. “You still have five hours left in your shift. How are you going to work with—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Doesn’t bother me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Bullshit.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Hey. You think I’m unfit to work, I’ll go home.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“That’s selfish. Who am I going to get to fill in for you at the last minute?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy thought a moment, then nodded. “Definitely one of the drawbacks of being self-employed and running a business.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen leaned back in her seat. Amy read her expression as one of disapproval.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan appeared with another beer—no glass this time since the first one had gone untouched.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "21",
      "epub:type": "pagebreak",
      "id": "page21",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Don’t drink that just yet,” Ellen said. “There’s a story here. And I want to hear the lucid version. Or … the semi-lucid version.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Trust me. You don’t want to hear either one.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen gave Amy’s forearm a firm squeeze. “I do. Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen was about her mother’s age—or the age her mom would be if she were still alive. Amy stared at her drink. “I was living my dream. And then in an instant, it was gone. Tragic, actually. Because that part of it wasn’t a dream. It was reality.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Tell me more,” Ellen said. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Not my favorite thing to do,” Amy said, reaching out and picking up the bottle. “Talking about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“When did this … happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Seven years, two months, and three days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Joan swung up alongside the table with two plates and set them in front of the two women.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“What was this tragedy that changed your life?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy stared at her burger. “I lost my girl. And my husband.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Lost them? How?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Our car was broadsided by a truck. They were killed. I survived.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I’m so sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy laughed. “Yeah.” She made eye contact with Ellen. “I’ve heard it. But no one knows what it’s like. No one understands. You "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("can’t")]), _vm._v(" until you’ve lived through something like that.” She dropped her gaze. Grabbed the bottle, put it to her lips, then pulled it away and picked at the corner of the label instead.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you get help?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy canted her eyes ceiling-ward. “Let’s see. Depression. Survivor’s guilt. PTSD. Destructive tendencies. Yeah, I got help. No—I "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("went")]), _vm._v(" for help. Didn’t "), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("get")]), _vm._v(" any. Lost my family, lost my job, lost my career. Lost my life.”")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "page22",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“So you really were an attorney?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Partner in the second largest law firm in Boston. My husband and I couldn’t get pregnant so we tried IVF. And then we were blessed with the miracle. My daughter. Lindy.” Amy stared off at the back of the restaurant over Ellen’s right shoulder. Her eye began twitching again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“You’re right. I can’t imagine what that was like.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy smirked—an “I told you so” look.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did you have a support network? Friends? Other attorneys at the firm?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Lost it all after having a nervous breakdown. Excuse me. A severe depressive episode.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“How severe?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Her right eyelid twitched faster. “Very.” Amy took a swig of beer. “Tried to kill myself.” She held out her left wrist, displaying a faint transverse scar. “I was bleeding out and a friend found me.” She stared at the healed skin. “Spent time on a shrink’s couch, my bloodstream filled with all sorts of psychoactive cocktails.” She snorted. “"), _c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("Therapy")]), _vm._v(".” Amy set the bottle down. “They wanted to talk about the accident, about my daughter. About my husband. I couldn’t. Didn’t want to. So they didn’t really have much to offer me. Wasn’t their fault. I just wasn’t ready. I stopped going and tried to deal with it myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen was staring, brow firm with concern.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy gestured at her wrist. “Obviously, that didn’t work out too well, either. Spent several weeks in an institution on suicide watch. Multiple times.” She took another swig. “I needed a clean break, a move somewhere across the country.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Did that help?” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Amy sighed—a long one, the kind that told you it was not a simple answer. “I was on meds. Lots of meds. Still on some of them. But I had to get a job because I’d eaten away most of our "), _c('span', {
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "page23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("savings …” Amy chuckled derisively. “Funny thing about large gaps in unemployment following a major life tragedy. People can connect the dots. And with a flood of lawyers clamoring for jobs, with no book of business and a sketchy gap on my CV, no way in hell would a firm hire me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“No book of business?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Lawyer speak for no clients.” Amy stared off at the table. What she did not tell Ellen was that she had a hard time thinking about returning to that kind of lifestyle. Practicing law would forever keep those wounds open, like a festering bedsore that never healed. Leaving Boston was step one. Leaving the legal profession was a close second. “I finally started looking for different types of work. Minimum wage positions in stable businesses. Do my work and go home. Minimal responsibility. Minimal stress.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("Ellen leaned back in her seat. “So everything you told me during your interview—”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“A lie. Never worked in a bakery. Learned it all at YouTube University.” Amy forced a half smile.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“I should fire you for lying to me, falsifying your work history.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“And you’d be completely justified. But you won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Why so sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_vm._v("“Because that’d be very harsh. Cold-hearted. And you’re one of the nicest people I’ve ever met.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_vm._v("Ellen’s gaze worked its way across Amy’s face before she answered. “Fine. Then earn your keep. When we get back, call that contractor and use your attorney tone to scare the living daylights out of him. My daughter’s getting married and I need a functional backyard.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032a2f38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504095785-1.vue
// module id = 78
// module chunks = 0